import { render, staticRenderFns } from "./EmployeeMassInvite.vue?vue&type=template&id=b982315c&scoped=true"
import script from "./EmployeeMassInvite.vue?vue&type=script&lang=js"
export * from "./EmployeeMassInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b982315c",
  null
  
)

export default component.exports